import React from "react";

import styles from "./sideContentBlock.module.scss";

const SideContentBlock = (props) => {
  const minHeight = props.minHeight;

  if (minHeight !== null) {
    return (
      <div className={styles.container_sideContentBlock} style={{ minHeight: minHeight }}>
        {props.children}
      </div>
    );
  }

  return <div className={styles.container_sideContentBlock}>{props.children}</div>;
};

export default React.memo(SideContentBlock);
